import React from 'react';

interface GlobalLayoutProps {
  children: React.ReactNode;
}

export function GlobalLayout({ children }: GlobalLayoutProps) {
  console.log('GlobalLayout', children);
  return (
    <>
      {/* Google Tag Manager noscript fallback */}
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-XXXXXXX"
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        />
      </noscript>

      {/* Main content */}
      {children}

      {/* Footer ghost element for consistent spacing */}
      <div className="c-footer__ghost js-footer-ghost" />
    </>
  );
}
